<template>
  <div style="position: relative">
    <!-- ***ใส่ filter sort***-->
    <v-layout wrap align-center class="mt-4">
      <v-flex xs4 sm4 md6 class="main-title">MESSENGER</v-flex>
      <v-flex xs10 sm4 md3>
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn"
          v-if="sort_column != 'order_id' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'order_id'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn"
          v-if="sort_column != 'order_id' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'order_id'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm3 d-flex class="text-xs-center">
        <download-excel
          :data="export_messegner_format"
          :fields="{
            No: 'no',
            'Order code': 'Order_code',
            'Order ref.': 'order_base_code',
            'Rider name': 'Rider',
            'Vehicle type': 'Vehicle_type',
            'Start point': 'Start_point',
            'End point': 'End_point',
            Price: 'Price',
            'Payment type': 'order_payment',
            Status: 'status',
          }"
          style="position: absolute; top: 10px; right: 10px"
          :name="
            'OrderReport-Messenger_' +
            search_config.datetime_start +
            '_to_' +
            search_config.datetime_end +
            '.xls'
          "
        >
          <v-btn icon> <v-icon large color="black">print</v-icon>.xls </v-btn>
        </download-excel>
        <download-excel
          type="csv"
          :data="export_messegner_format"
          :fields="{
            No: 'no',
            'Order code': 'Order_code',
            'Order ref.': 'order_base_code',
            'Rider name': 'Rider',
            'Vehicle type': 'Vehicle_type',
            'Start point': 'Start_point',
            'End point': 'End_point',
            Price: 'Price',
            'Payment type': 'order_payment',
            Status: 'status',
          }"
          style="position: absolute; top: 10px; right: 90px"
          :name="
            'OrderReport-Messenger_' +
            search_config.datetime_start +
            '_to_' +
            search_config.datetime_end +
            '.csv'
          "
        >
          <v-btn icon> <v-icon large color="black">print</v-icon>.csv </v-btn>
        </download-excel>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="messenger_order_report"
      class="elevation-1"
      style="background-color: white; padding: 10px; border-radius: 10px"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color: black"
        >{{ props.header.text }}</template
      >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.no }}</td>
        <td>{{ props.item.Order_code }}</td>
        <td>{{ props.item.order_base_code }}</td>
        <td>{{ props.item.Rider }}</td>
        <td>{{ props.item.Vehicle_type }}</td>
        <td>{{ props.item.Start_point }}</td>
        <td>{{ props.item.End_point }}</td>
        <td class="text-xs-right">
          {{
            props.item.Price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}
        </td>
        <td class="text-xs-center">
          {{ props.item.order_payment }}
        </td>
        <td
          :style="
            props.item.status == 'completed' ? 'color:green;' : 'color:red;'
          "
        >
          {{ props.item.status }}
        </td>
        <td class="text-xs-center">
          <v-btn
            small
            color="primary"
            class="black--text"
            :to="
              '/weserve_admin_login/control/' +
              $store.state.backOffice.province +
              '/report/order_report/order_detail/' +
              props.item.order_id +
              '/messenger'
            "
            >detail</v-btn
          >
        </td>
      </template>
      <template slot="footer">
        <td colspan="6" class="text-xs-center">
          <strong>Total</strong>
        </td>
        <td class="text-xs-center">
          {{
            parseFloat(total_net_price)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}
        </td>
        <td></td>
        <td></td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      total_net_price: 0,
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "name",
        },
        { text: "Order code", value: "id", sortable: false },
        { text: "Order ref", value: "id", sortable: false },
        { text: "Rider", value: "rider", sortable: false },
        {
          text: "Vehicle type",
          value: "vehicle_type",
          sortable: false,
          align: "center",
        },
        { text: "Start point", value: "start_point", sortable: false },
        { text: "End point", value: "end_point", sortable: false },
        { text: "Price", value: "price", align: "center", sortable: false },
        {
          text: "Payment type",
          value: "order_payment",
          sortable: false,
        },
        { text: "Status", sortable: false, align: "center" },
        { text: "Order detail", sortable: false, align: "center" },
      ],
      column_items: [
        { text: "Rider", value: "Rider", sortable: false },
        { text: "Price", value: "Price", align: "center", sortable: false },
      ],
      asc_desc: "asc",
      sort_column: "order_id",
      isSort: false,
    };
  },
  watch: {
    messenger_order_report: {
      handler: function () {
        this.calTotalPrice();
        if (this.isSort == false) {
          this.asc_desc = "asc";
          this.sort_column = "order_id";
        }
      },
      deep: true,
    },
  },
  methods: {
    calTotalPrice() {
      this.total_net_price = 0;
      for (let val of this.messenger_order_report) {
        this.total_net_price = this.total_net_price + parseFloat(val.Price);
      }
    },
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "order_id";
        this.asc_desc = "asc";
      }
      this.isSort = true;
      const send_json_data = {
        data: this.messenger_order_report,
        field: this.sort_column,
        asc_desc: this.asc_desc,
      };
      await this.$store.dispatch("sortData", send_json_data);
      await this.$store.commit("fetchReportDashboard/getExportMessReport");
      this.$store.commit("fetchReportDashboard/getSummaryExportMessenger");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    },
  },
  computed: {
    ...mapState({
      messenger_order_report: (state) =>
        state.fetchReportDashboard.messenger_order_report,
      search_config: (state) => state.fetchReportDashboard.search_config,
      export_messegner_format: (state) =>
        state.fetchReportDashboard.export_messegner_format,
    }),
  },

  created() {
    this.calTotalPrice();
  },
};
</script>
<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
</style>
